"use strict";
/*
 * Created on 16.10.2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * @author MSu
 */


var PromotionConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(PromotionConverter, _DataObjectConverter_);

  function PromotionConverter() {
    _classCallCheck(this, PromotionConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(PromotionConverter).apply(this, arguments));
  }

  return PromotionConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.PromotionConverter = PromotionConverter;